import {
  Container,
  Stack,
  LinearProgress,
  Alert,
} from '@mui/material';
import React, { useEffect } from 'react';

import TurnOverview from './Components/TurnOverview';
import { useState } from 'react';

import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';

import useFetchMyTurns from './Hooks/useFetchMyTurns';

const TurnList = () => {
  const [forceRender, setForceRender] = useState(false);
  const [loading, setLoading] = useState(false);
  const [myTurns, setMyTurns] = useState(null);

  useFetchMyTurns(setMyTurns, forceRender);

  // const myTurns = GetPostResponse(
  //   `${process.env.REACT_APP_API_URL_API_GET_MY_NOBAT}`,
  //   true,
  //   {
  //     idPatient: user?.IdPatient,
  //   },
  //   forceRender
  // )?.Data;

  const noDataMsg = FindLangKey(
    'general-public-flat-alert-no-data'
  );

  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  const gridCondition =
    myTurns?.length > 1 && screenWidth > 1024;

  // console.log('myTurns====>', myTurns);

  return (
    <React.Fragment>
      <Container>
        <Stack
          mt="1em"
          gap="0.5em"
          pb="1em"
          display={gridCondition ? 'grid' : ''}
          sx={{
            gridTemplateColumns: gridCondition
              ? 'repeat(2, 1fr) !important'
              : '',
          }}
        >
          {!myTurns ? (
            <LinearProgress />
          ) : myTurns?.length > 0 ? (
            myTurns?.map((turn) => (
              <TurnOverview
                turn={turn}
                key={turn.IdNobat}
                setForceRender={setForceRender}
                loading={loading}
                setLoading={setLoading}
                screenWidth={screenWidth}
              />
            ))
          ) : (
            <Alert
              severity={'warning'}
              dir="rtl"
              variant="outlined"
            >
              {noDataMsg}
            </Alert>
          )}
        </Stack>
      </Container>
    </React.Fragment>
  );
};

export default TurnList;

// const leadingActions = () => (
//     <LeadingActions>
//       <SwipeAction onClick={() => console.info("swipe action triggered")}>
//         Action name
//       </SwipeAction>
//     </LeadingActions>
//   );

//   const trailingActions = () => (
//     <TrailingActions>
//       <SwipeAction
//         destructive={true}
//         onClick={() => console.info("swipe action triggered")}
//       >
//         Delete
//       </SwipeAction>
//     </TrailingActions>
//   );
